import React, {   } from 'react';
import {
    Table,
    TableBody,
    TableContainer,
    TableRow,
    Paper,
    TableCell,
    TableHead
} from '@material-ui/core';

import { FaturaItem } from './models';

export const FaturaItensTable = (props: { rows: FaturaItem[] }) => {

    const rows = props.rows;

    return <TableContainer component={Paper}>
        <Table size="small" aria-label="a dense table">
            <TableHead>
                <TableRow>
                    <TableCell align="left">Tipo</TableCell>
                    <TableCell align="right">Data</TableCell>
                    <TableCell align="left">Nota</TableCell>
                    <TableCell align="left">Placa</TableCell>
                    <TableCell align="left">Produto</TableCell>
                    <TableCell align="right">Qtd</TableCell>
                    <TableCell align="right">Preco</TableCell>
                    <TableCell align="right">Bruto</TableCell>
                    <TableCell align="right">Desc.</TableCell>
                    <TableCell align="right">Acres.</TableCell>
                    <TableCell align="right">Liquido</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {rows.map((row, idx) => (
                    <TableRow key={idx}>
                        <TableCell align="left">{row.tipo}</TableCell>
                        <TableCell align="right">{new Date(row.data).toLocaleDateString()}</TableCell>
                        <TableCell align="left">{row.notaModelo} {row.notaSerie} {row.notaNumero} {row.notaChave}</TableCell>
                        <TableCell align="left">{row.placa}</TableCell>
                        <TableCell align="left">{row.produtoCod} {row.produtoNome}</TableCell>
                        <TableCell align="right">{row.quantidade}</TableCell>
                        <TableCell align="right">{row.preco}</TableCell>
                        <TableCell align="right">{row.totalBruto}</TableCell>
                        <TableCell align="right">{row.descontos}</TableCell>
                        <TableCell align="right">{row.acrescimos}</TableCell>
                        <TableCell align="right">{row.totalLiquido}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>;
};
